"use strict";

import $ from 'jquery';
import moment from 'moment';

import {dateFormatConstants, convertDateStringToDate} from '../common/Utils';

const FORM_SELECTOR = '#terms-form';

export default  {
    wireup : function (){

        let theForm = $(FORM_SELECTOR);
        theForm.validate();

        //the signature line should only be enabled if user accepts all terms
        theForm.on('change', ':checkbox', function(){
            let allChecked = theForm.find('#accept-terms, #accept-bylaw')
                                    .filter(':not(:checked)')
                                    .length === 0;

            theForm.find('#fullName').prop('disabled', !allChecked);
        });

    },
    validate : function (){

        let isValid = $(FORM_SELECTOR).valid();

        return new Promise(function(resolve){
            resolve(isValid);
        });
    },
    handleDateOfBirthChange : function(dateOfBirth) {
        const dob = convertDateStringToDate(dateOfBirth);
        const now = moment();

        // display the parental consent if the student is under 18 years old
        $(FORM_SELECTOR).find('.js-parental-consent').toggleClass('collapse', now.diff(dob, 'years') > 17);
    }
};


// WEBPACK FOOTER //
// /mnt/appdata/jenkins/jobs/EC_Registration/workspace/web/app/~/eslint-loader!./js/register/TermsAndConditionsSection.js